export default __webpack_public_path__ + "static/media/eat-scale@2x.aced0c75.png";